import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useMembershipModalState } from '../../../../../modalContext';
import {
	getAverageAmountExperimentVariant,
	getAverageAmount,
} from '../../../../../shared/utils/averageAmountExperiment';

export const useAverageAmountExperimentMessage = (): ((startDate: string) => string | undefined) => {
	const [{ ppmuAverageAmountExperiment, currencyCode }] = useMembershipModalState();
	const { localizeCurrency } = useI18n();

	const variant = getAverageAmountExperimentVariant(ppmuAverageAmountExperiment);
	const averageAmount = getAverageAmount(ppmuAverageAmountExperiment);

	return useCallback(
		(startDate: string) => {
			if (variant !== 'variant_1' || !averageAmount) return undefined;
			const localizedAverageAmount = localizeCurrency(averageAmount, currencyCode);
			// TODO: add translation when productized
			return `Most members contribute <strong>${localizedAverageAmount}/mo.</strong> Choose the amount for your monthly contribution starting ${startDate}.`;
		},
		[variant, averageAmount, currencyCode, localizeCurrency],
	);
};
